import {
    apiRequest,
    tukinDetail
} from "../../../../../services/adapters/kepegawaian/uangmakanService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", tukinDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository